<template>
  <div class="hello">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <div>
          <span>{{hallInfo.hallName}}</span>
          <span>请选择您所需要预约的部门</span>
          <span>{{ data.length === 0 ? '加载中' : data[active].deptName }}</span>
        </div>
        <div class="input-left">
          <el-input
              v-model="keyword"
              @change="getDeptList"
              placeholder="请输入部门名称"
              clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="box">
        <div v-for="(i,index) in data"
             class="items"
             :class="active===index?'activeClass':''"
             @click="itemsClick(index)">
          {{ i.deptName }}
        </div>
      </div>
    </el-card>
    <div class="pages">
      <el-pagination
          :current-page="page"
          :page-size="size"
          :total="total"
          :page-sizes="[20, 40]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import wasm from "@/mixins/wasm"
import {getDeptList} from "@/api/dept"
import {getHallInfo} from "@/api/hall";
export default {
  name: 'HelloWorld',
  mixins: [wasm],
  async mounted() {
    await this.initwasm().then(() => {
      this.getHallInfo()
      this.getDeptList()
    })
  },
  data() {
    return {
      keyword: '',
      active: 0,
      page: 1,
      size: 20,
      total: 0,
      data: [],
      hallInfo: {}
    }
  },
  methods: {
    getHallInfo() {
      let data = {
        hallId: this.$route.query.hallId,
      }
      getHallInfo(data).then(res => {
        this.hallInfo = res.data.info
      })
    },
    getDeptList() {
      let data = {
        hallId: this.$route.query.hallId,
        deptName: this.keyword
      }
      getDeptList(this.page, this.size, data).then(res => {
        this.data = res.data.rows
        this.total = res.data.records
        this.itemsClick(0)
      })
    },
    handleSizeChange(val) {
      this.size = val
      this.getDeptList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getDeptList()
    },
    itemsClick(index) {
      this.active = index
      this.$store.commit('setDept', this.data[index])
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .input-left {
    width: 20%;
  }

  span {
    margin: 0 10px;
  }

  span:nth-child(1) {
    font-weight: 500;
  }

  span:nth-child(3) {
    color: #427AF4;
  }
}

.box {
  display: grid;
  padding: 10px;
  justify-content: space-between;
  grid-template-columns: repeat(4, 264px); /* 横向平均分为4列 */
  grid-template-rows: repeat(7, 70px); /* 纵向最大为7行，根据内容自动调整 */
  gap: 20px; /* 设置行和列之间的间隙 */
  height: 300px;
  overflow: auto;

  .items {
    box-shadow: 0px 4px 5.8px 0px #C0CBD769;
    padding: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 2px solid #fff;
  }

  .activeClass {
    background: #427AF4;
    color: #fff;
  }
}

::v-deep .pages {
  margin: 20px 0;

  .el-pagination {
    display: flex;
  }

  .el-pagination__sizes {
    margin-left: auto;
  }
}
</style>
